import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import './UserMenu.scss';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../stores/globalStore';
import { setLogOut } from '../../stores/authenticationStore';
import { AlertSeverity } from '../../utils/enum/Alerts';
import { setAlertData } from '../../stores/alertStore';

function UserMenu({ closeDrawer }: any) {
  const { t } = useTranslation();

  const connectedUser = useSelector((state: RootState) => state.authentication.connectedUser);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logOut = () => {
    axios.get(`${window._env_.REACT_APP_API_URI}/user/logout`)
      .then(() => {
        closeDrawer();
        dispatch(setLogOut());
        navigate('/login');
      })
      .catch((error) => {
        if (error.response) {
          const err = error.response;
          console.error(err);
          dispatch(setAlertData({
            message: err.data.message,
            severity: AlertSeverity.ERROR,
            open: true,
          }));
        }
        console.error(error.response);
      });
  };

  return (
    <div className="user-menu">
      <FontAwesomeIcon className="user-icon" icon={faUserCircle} />
      <div className="user-detail">
        <div>{connectedUser.name}</div>
        <div>{connectedUser.email}</div>
        <div>{connectedUser.role}</div>
      </div>
      <div className="user-link-div">
        <Link to="/profile" onClick={() => closeDrawer()} className="user-link">{ t('UserMenu.profile') }</Link>
      </div>
      <div className="logout-button">
        <Button variant="contained" color="secondary" onClick={logOut}>{ t('UserMenu.logout') }</Button>
      </div>
    </div>
  );
}

UserMenu.propTypes = {
  // eslint-disable-next-line react/require-default-props
  closeDrawer: PropTypes.func
};

export default UserMenu;
